/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type LoadingStatusEnum =
  (typeof LoadingStatusEnum)[keyof typeof LoadingStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoadingStatusEnum = {
  NotLoaded: 0,
  Loaded: 1,
  Unloaded: 2,
} as const;
